import { render, staticRenderFns } from "./updataCommodity.vue?vue&type=template&id=45cfc434&scoped=true"
import script from "./updataCommodity.vue?vue&type=script&lang=js"
export * from "./updataCommodity.vue?vue&type=script&lang=js"
import style0 from "./updataCommodity.vue?vue&type=style&index=0&id=45cfc434&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cfc434",
  null
  
)

export default component.exports